import { useTranslation } from '@lt/localization';
import React from 'react';
import { UNKNOWN_LUGGAGE } from 'checkout/CheckoutRoutes/PackageCheckout/components/Flights/constants';
import styled from 'styled-components';
import TransferMedInsuranceInfo from '../../../TransferMedInsuranceInfo';
import type { AdditionalsSummaryInfo, FlightSummaryInfo } from '../../types';
import FlightTypes from './components/FlightTypes';
import FlightsTime from './components/FlightsTime';
import { TEST_ID_MOBILE_SUMMARY_FLIGHTS_CHANGE_BTN } from './constants';

type Props = {
  startDate: string;
  endDate: string;
  flight?: FlightSummaryInfo;
  additionals: AdditionalsSummaryInfo;
  onClick: () => void;
  isFlightChangable: boolean;
  operatorID: number;
};

const FlightsSummary = (props: Props): JSX.Element | null => {
  const { t } = useTranslation();

  const {
    flight,
    additionals,
    onClick,
    startDate,
    endDate,
    isFlightChangable,
    operatorID,
  } = props;

  if (!flight) return null;

  return (
    <Wrapper>
      <Title>{t('checkout.summary.flights.title')}</Title>
      <FlightTypes
        toClass={flight.to.class}
        toType={flight.to.type}
        backClass={flight.back[0].class}
        backType={flight.back[0].type}
        toWarning={flight.back[0].warning}
        backWarning={flight.back[0].warning}
        isFlightChangable={isFlightChangable}
        operatorID={operatorID}
      />
      <FlightsTime
        to={{
          departureTime: flight.to.departure,
          arrivalTime: flight.to.arrival,
          date: startDate,
          luggage: isFlightChangable ? UNKNOWN_LUGGAGE : flight.to.luggage,
        }}
        back={{
          departureTime: flight.back[0].departure,
          arrivalTime: flight.back[0].arrival,
          date: endDate,
          luggage: isFlightChangable ? UNKNOWN_LUGGAGE : flight.back[0].luggage,
        }}
        isFlightChangable={isFlightChangable}
      />
      <TransferMedInsuranceInfo
        isMobile
        sidebar={false}
        insurance={additionals.insurance}
        transfer={additionals.transfer}
        transferPrivate={additionals.transferPrivate}
      />
      <ChangeFlightsBtn
        data-testid={TEST_ID_MOBILE_SUMMARY_FLIGHTS_CHANGE_BTN}
        onClick={onClick}
      >
        {t('checkout.summary.flights.buttonText')}
      </ChangeFlightsBtn>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  font-size: 14px;
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const ChangeFlightsBtn = styled.div`
  color: var(--secondary);
  cursor: pointer;
`;

const Title = styled.div`
  margin-bottom: -4px;
  font-size: 12px;
  line-height: 16px;
  color: #919499;
`;

export default FlightsSummary;
